import React from 'react';

import { Background } from '../components/Background';
import { Banner } from '../components/Banner';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
import { PageTemplate } from '../components/PageTemplate';

export const Privacy = React.memo(() => (
  <div className="relative size-full">
    <Background />
    <Navbar />
    <div className="z-10 flex flex-col">
      <PageTemplate>
        <div className="flex h-[260px] flex-col items-center justify-start text-center">
          <button
            className="w-[121px] cursor-pointer rounded-full bg-[#FF9983] p-1 text-[13px] font-medium leading-[23px] 
          text-[#120A0B] transition-transform duration-300 ease-in-out hover:rotate-[-10deg] hover:scale-110 hover:shadow-xl"
            id="easter-egg"
          >
            Privacy Policy
          </button>

          <h1 className="text-[63px] font-bold leading-[73px] text-[#120A0B]">Privacy Policy</h1>
          <h2 className="mt-[30px] text-[17px] leading-[30px] text-[#454140]">
            Your privacy is important to us. This policy outlines how Webcrumbs collects, uses, <br />
            and safeguards your data while using Frontend AI.
          </h2>
        </div>

        <div className="flex flex-col items-start justify-start">
          <div className="gap-[31px]">
            <h1 className="text-[33px] font-bold leading-[51px] text-[#120A0B]">Introduction</h1>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs is committed to protecting your privacy and ensuring that your personal data is handled
              securely. This Privacy Policy governs how we collect, use, and disclose information from users ("Users")
              who interact with our platform, including our AI-powered Frontend AI tool. By accessing or using our
              services, you agree to the terms of this Privacy Policy.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Data We Collect</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              When you interact with Webcrumbs, we collect certain information to improve our services. We may use your
              IP address to determine eligibility for geo-localized discounts, and your device information helps us
              grant free AI generations where applicable. If you log in through email, Google or GitHub, we receive your
              email and authentication details to manage your account securely. If you choose to subscribe, Webcrumbs
              only receives anonymized data from Stripe, which we link to your account to enable access to premium
              features. Additionally, your last AI-generated component is stored locally in your browser, ensuring you
              can revisit recent generations.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">
              User-Generated Content & AI Training
            </h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Any content you create using Webcrumbs is yours to use, as long as it does not infringe on others'
              intellectual property (IP) rights. By default, your components remain private, even on the free plan. If
              you choose to submit content to our Templates section, you guarantee that it is open-source, does not
              include personal information, and does not violate any IP rights. We store AI-generated content and may
              anonymize this data for model training. If you are on an Enterprise plan, you may be exempt from this
              process.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">How We Protect Your Data</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Your data security is our priority. Webcrumbs’ servers are located in the United States, and all data is
              encrypted in transit to prevent unauthorized access. We implement security measures to safeguard your
              information from breaches, unauthorized access, or alterations. While we take extensive precautions, no
              digital transmission or storage method is completely secure, so we encourage users to take care in sharing
              personal details.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Third-Party Services</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs integrates with Clarity and Google Analytics 4 (GA4) to analyze user engagement and improve our
              platform. These third-party services may use cookies and collect anonymized usage data. Webcrumbs does not
              sell, trade, or rent personal information to outside parties.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Cookies</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              We do not use cookies. We value your privacy and rely on localStorage to store your preferences locally in
              your browser. However, third-party services like Clarity and GA4 may use cookies independently, which you
              can manage in your browser settings.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Your Rights & Contact</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Users have rights under applicable laws, including the ability to request access to personal data, rectify
              inaccurate information, or request deletion where legally applicable. For any privacy-related questions or
              data requests, you can contact our team at help@webcrumbs.ai.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Changes to This Privacy Policy</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs reserves the right to modify this Privacy Policy at any time. Changes will be reflected on this
              page with an updated revision date. Users are encouraged to review this policy periodically to stay
              informed on how Webcrumbs protects their data.
            </p>
          </div>
        </div>
      </PageTemplate>
      <Banner />
      <Footer />
    </div>
  </div>
));
